import api from './api';

export default {
  creditData: async (): Promise<any> => {
    return api.get('credit-request/import-all');
  },

  personData: async (): Promise<any> => {
    return api.get('person/import-all');
  },

  states: async (): Promise<any> => {
    return api.get('person/city/getAll');
  },

  cities: async (): Promise<any> => {
    return api.get('person/state/getAll');
  },
};
